// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".thumbnails[data-v-cfb72b3a]{max-height:600px;max-width:600px;position:relative}.thumbnails__image[data-v-cfb72b3a]{border-radius:.25rem;cursor:pointer;display:block;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;transition-duration:.15s}.thumbnails__image[data-v-cfb72b3a]:last-child{margin-bottom:0}.thumbnails__image[data-v-cfb72b3a]:hover{opacity:1}.image[data-v-cfb72b3a]{aspect-ratio:1/1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
